import React, { useEffect, useRef, useState } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import "./overflow-tooltip.scss";

export const hasTooltipValue = (value) => (
  value !== null && value !== undefined && String(value).trim() !== ""
);

const OverflowTooltip = ({ value, size = "medium", className = "" }) => {
  const textRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const hasValue = hasTooltipValue(value);
  const text = hasValue ? String(value) : "-";

  useEffect(() => {
    const updateOverflow = () => {
      const element = textRef.current;
      setIsOverflowing(Boolean(
        hasValue
        && element
        && element.scrollWidth > element.clientWidth
      ));
    };

    updateOverflow();

    const element = textRef.current;
    const ResizeObserverClass = typeof window !== "undefined" ? window.ResizeObserver : null;

    if (element && ResizeObserverClass) {
      const observer = new ResizeObserverClass(updateOverflow);
      observer.observe(element);
      return () => observer.disconnect();
    }

    window.addEventListener("resize", updateOverflow);
    return () => window.removeEventListener("resize", updateOverflow);
  }, [hasValue, text, size]);

  const classes = [
    "overflow-tooltip",
    `overflow-tooltip--${size}`,
    className,
  ].filter(Boolean).join(" ");

  return (
    <Tooltip
      title={text}
      placement="top"
      arrow
      disableHoverListener={!isOverflowing}
      disableFocusListener={!isOverflowing}
      disableTouchListener={!isOverflowing}
    >
      <span
        ref={textRef}
        className={classes}
        tabIndex={isOverflowing ? 0 : undefined}
      >
        {text}
      </span>
    </Tooltip>
  );
};

export default OverflowTooltip;
